import React from 'react'

interface ArbiterLogoProps {
  size?: number
  className?: string
}

export function ArbiterMark({ size = 36, className = '' }: ArbiterLogoProps): React.ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Arbiter"
    >
      <path fill="#0097db" d="
        M 564.01 385.76
        Q 567.68 394.83 573.41 402.79
        A 0.42 0.42 0.0 0 1 573.28 403.40
        C 559.44 411.40 545.18 414.04 529.77 413.64
        Q 510.16 413.13 496.61 412.68
        C 475.28 411.98 463.12 411.79 446.54 407.47
        L 511.49 302.98
        A 0.53 0.52 44.8 0 1 512.38 302.98
        L 564.01 385.76
        Z"/>
      <path fill="#0080bc" d="
        M 564.01 385.76
        L 619.21 474.44
        C 611.76 477.73 605.14 478.05 596.39 477.88
        Q 581.97 477.60 565.24 474.62
        C 554.66 472.74 545.38 469.09 537.63 462.96
        Q 533.40 459.61 528.30 454.27
        L 512.41 428.04
        A 0.79 0.79 0.0 0 0 511.06 428.04
        L 497.05 450.92
        C 485.16 456.81 474.02 458.25 460.58 458.40
        C 445.07 458.58 431.78 458.99 417.33 454.39
        L 446.54 407.47
        C 463.12 411.79 475.28 411.98 496.61 412.68
        Q 510.16 413.13 529.77 413.64
        C 545.18 414.04 559.44 411.40 573.28 403.40
        A 0.42 0.42 0.0 0 0 573.41 402.79
        Q 567.68 394.83 564.01 385.76
        Z"/>
      <path fill="#0071a8" d="
        M 497.05 450.92
        L 457.73 515.48
        C 432.06 520.21 405.92 520.03 380.80 512.88
        L 417.33 454.39
        C 431.78 458.99 445.07 458.58 460.58 458.40
        C 474.02 458.25 485.16 456.81 497.05 450.92
        Z"/>
      <path fill="#0071a8" d="
        M 619.21 474.44
        L 643.54 513.46
        Q 633.02 515.02 619.22 515.97
        Q 587.79 518.14 559.72 505.53
        L 528.30 454.27
        Q 533.40 459.61 537.63 462.96
        C 545.38 469.09 554.66 472.74 565.24 474.62
        Q 581.97 477.60 596.39 477.88
        C 605.14 478.05 611.76 477.73 619.21 474.44
        Z"/>
      <path fill="#005580" d="
        M 643.54 513.46
        L 703.29 609.15
        Q 695.60 616.69 687.03 618.31
        Q 672.54 621.07 653.81 618.31
        C 638.55 616.07 626.56 607.51 615.35 597.52
        L 559.72 505.53
        Q 587.79 518.14 619.22 515.97
        Q 633.02 515.02 643.54 513.46
        Z"/>
      <path fill="#005580" d="
        M 380.80 512.88
        C 405.92 520.03 432.06 520.21 457.73 515.48
        L 388.14 629.45
        Q 371.78 632.01 355.62 633.48
        C 339.63 634.93 325.03 632.80 312.69 622.14
        L 380.80 512.88
        Z"/>
      <path fill="#005580" d="
        M 580.86 615.41
        L 560.57 626.65
        A 2.12 2.04 -58.7 0 1 559.55 626.92
        Q 535.78 627.01 503.00 626.99
        Q 496.52 626.99 490.61 625.81
        Q 485.73 624.84 476.61 622.54
        Q 459.90 618.32 449.16 605.37
        L 473.88 564.71
        A 1.94 1.94 0.0 0 1 475.53 563.79
        L 548.24 563.79
        A 1.21 1.19 -15.7 0 1 549.26 564.35
        L 580.86 615.41
        Z"/>
      <path fill="#003350" d="
        M 703.29 609.15
        L 773.63 722.34
        A 0.35 0.35 0.0 0 1 773.35 722.87
        Q 767.92 723.09 767.44 723.09
        Q 761.58 723.07 632.75 723.03
        Q 630.57 723.02 629.40 722.61
        A 1.24 1.19 82.7 0 1 628.77 722.10
        L 589.60 657.83
        A 0.58 0.58 0.0 0 1 590.10 656.95
        L 651.70 656.95
        A 0.20 0.20 0.0 0 0 651.87 656.64
        L 615.35 597.52
        C 626.56 607.51 638.55 616.07 653.81 618.31
        Q 672.54 621.07 687.03 618.31
        Q 695.60 616.69 703.29 609.15
        Z"/>
      <path fill="#003350" d="
        M 449.16 605.37
        Q 459.90 618.32 476.61 622.54
        Q 485.73 624.84 490.61 625.81
        Q 496.52 626.99 503.00 626.99
        Q 535.78 627.01 559.55 626.92
        A 2.12 2.04 -58.7 0 0 560.57 626.65
        L 580.86 615.41
        L 587.72 626.59
        A 0.38 0.38 0.0 0 1 587.40 627.17
        L 436.70 627.17
        A 0.44 0.44 0.0 0 1 436.32 626.50
        L 449.16 605.37
        Z"/>
      <path fill="#003350" d="
        M 312.69 622.14
        C 325.03 632.80 339.63 634.93 355.62 633.48
        Q 371.78 632.01 388.14 629.45
        L 371.82 656.24
        A 0.51 0.50 15.9 0 0 372.25 657.01
        L 433.95 657.01
        A 0.39 0.39 0.0 0 1 434.29 657.60
        C 432.44 660.78 429.70 664.36 427.53 668.05
        Q 422.21 677.09 395.14 721.97
        A 2.28 2.26 15.4 0 1 393.19 723.07
        L 250.88 723.07
        A 0.66 0.65 16.0 0 1 250.32 722.07
        L 312.69 622.14
        Z"/>
    </svg>
  )
}

interface ArbiterWordmarkProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function ArbiterWordmark({ size = 'md', className = '' }: ArbiterWordmarkProps): React.ReactElement {
  const iconSize = size === 'sm' ? 28 : size === 'lg' ? 48 : 36
  const textClass = size === 'sm' ? 'text-base' : size === 'lg' ? 'text-2xl' : 'text-lg'

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <ArbiterMark size={iconSize} />
      <span className={`font-bold tracking-tight text-primary ${textClass}`}>
        Arbiter
      </span>
    </div>
  )
}
